import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    if (status === "error") {
      toast.error(params.get("reason") || "Google sign-in failed");
      nav("/login");
      return;
    }
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data.user);
        toast.success("Signed in with Google");
        window.history.replaceState({}, "", "/browse");
        nav("/browse");
      } catch (e) {
        toast.error("Could not load your account after sign-in");
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-stone-600">Finishing sign-in…</div>
    </div>
  );
}
